export interface Country {
  code: string;
  label: string;
  flag: string;
}

export const ALL_COUNTRIES: Country[] = [
  { code: 'AF', label: 'Afghanistan', flag: '🇦🇫' },
  { code: 'ZA', label: 'Afrique du Sud', flag: '🇿🇦' },
  { code: 'AL', label: 'Albanie', flag: '🇦🇱' },
  { code: 'DZ', label: 'Algérie', flag: '🇩🇿' },
  { code: 'DE', label: 'Allemagne', flag: '🇩🇪' },
  { code: 'AD', label: 'Andorre', flag: '🇦🇩' },
  { code: 'AO', label: 'Angola', flag: '🇦🇴' },
  { code: 'SA', label: 'Arabie saoudite', flag: '🇸🇦' },
  { code: 'AR', label: 'Argentine', flag: '🇦🇷' },
  { code: 'AM', label: 'Arménie', flag: '🇦🇲' },
  { code: 'AU', label: 'Australie', flag: '🇦🇺' },
  { code: 'AT', label: 'Autriche', flag: '🇦🇹' },
  { code: 'AZ', label: 'Azerbaïdjan', flag: '🇦🇿' },
  { code: 'BS', label: 'Bahamas', flag: '🇧🇸' },
  { code: 'BH', label: 'Bahreïn', flag: '🇧🇭' },
  { code: 'BD', label: 'Bangladesh', flag: '🇧🇩' },
  { code: 'BE', label: 'Belgique', flag: '🇧🇪' },
  { code: 'BZ', label: 'Belize', flag: '🇧🇿' },
  { code: 'BJ', label: 'Bénin', flag: '🇧🇯' },
  { code: 'BY', label: 'Biélorussie', flag: '🇧🇾' },
  { code: 'MM', label: 'Birmanie', flag: '🇲🇲' },
  { code: 'BO', label: 'Bolivie', flag: '🇧🇴' },
  { code: 'BA', label: 'Bosnie-Herzégovine', flag: '🇧🇦' },
  { code: 'BW', label: 'Botswana', flag: '🇧🇼' },
  { code: 'BR', label: 'Brésil', flag: '🇧🇷' },
  { code: 'BG', label: 'Bulgarie', flag: '🇧🇬' },
  { code: 'BF', label: 'Burkina Faso', flag: '🇧🇫' },
  { code: 'BI', label: 'Burundi', flag: '🇧🇮' },
  { code: 'KH', label: 'Cambodge', flag: '🇰🇭' },
  { code: 'CM', label: 'Cameroun', flag: '🇨🇲' },
  { code: 'CA', label: 'Canada', flag: '🇨🇦' },
  { code: 'CV', label: 'Cap-Vert', flag: '🇨🇻' },
  { code: 'CF', label: 'Centrafrique', flag: '🇨🇫' },
  { code: 'CL', label: 'Chili', flag: '🇨🇱' },
  { code: 'CN', label: 'Chine', flag: '🇨🇳' },
  { code: 'CY', label: 'Chypre', flag: '🇨🇾' },
  { code: 'CO', label: 'Colombie', flag: '🇨🇴' },
  { code: 'KM', label: 'Comores', flag: '🇰🇲' },
  { code: 'CG', label: 'Congo-Brazzaville', flag: '🇨🇬' },
  { code: 'CD', label: 'Congo-Kinshasa', flag: '🇨🇩' },
  { code: 'KR', label: 'Corée du Sud', flag: '🇰🇷' },
  { code: 'KP', label: 'Corée du Nord', flag: '🇰🇵' },
  { code: 'CR', label: 'Costa Rica', flag: '🇨🇷' },
  { code: 'CI', label: 'Côte d\'Ivoire', flag: '🇨🇮' },
  { code: 'HR', label: 'Croatie', flag: '🇭🇷' },
  { code: 'CU', label: 'Cuba', flag: '🇨🇺' },
  { code: 'DK', label: 'Danemark', flag: '🇩🇰' },
  { code: 'DJ', label: 'Djibouti', flag: '🇩🇯' },
  { code: 'DM', label: 'Dominique', flag: '🇩🇲' },
  { code: 'EG', label: 'Égypte', flag: '🇪🇬' },
  { code: 'AE', label: 'Émirats arabes unis', flag: '🇦🇪' },
  { code: 'EC', label: 'Équateur', flag: '🇪🇨' },
  { code: 'ER', label: 'Érythrée', flag: '🇪🇷' },
  { code: 'ES', label: 'Espagne', flag: '🇪🇸' },
  { code: 'EE', label: 'Estonie', flag: '🇪🇪' },
  { code: 'US', label: 'États-Unis', flag: '🇺🇸' },
  { code: 'ET', label: 'Éthiopie', flag: '🇪🇹' },
  { code: 'FI', label: 'Finlande', flag: '🇫🇮' },
  { code: 'FR', label: 'France', flag: '🇫🇷' },
  { code: 'GA', label: 'Gabon', flag: '🇬🇦' },
  { code: 'GM', label: 'Gambie', flag: '🇬🇲' },
  { code: 'GE', label: 'Géorgie', flag: '🇬🇪' },
  { code: 'GH', label: 'Ghana', flag: '🇬🇭' },
  { code: 'GR', label: 'Grèce', flag: '🇬🇷' },
  { code: 'GD', label: 'Grenade', flag: '🇬🇩' },
  { code: 'GL', label: 'Groenland', flag: '🇬🇱' },
  { code: 'GP', label: 'Guadeloupe', flag: '🇬🇵' },
  { code: 'GT', label: 'Guatemala', flag: '🇬🇹' },
  { code: 'GN', label: 'Guinée', flag: '🇬🇳' },
  { code: 'GQ', label: 'Guinée équatoriale', flag: '🇬🇶' },
  { code: 'GW', label: 'Guinée-Bissau', flag: '🇬🇼' },
  { code: 'GY', label: 'Guyana', flag: '🇬🇾' },
  { code: 'HT', label: 'Haïti', flag: '🇭🇹' },
  { code: 'HN', label: 'Honduras', flag: '🇭🇳' },
  { code: 'HU', label: 'Hongrie', flag: '🇭🇺' },
  { code: 'IN', label: 'Inde', flag: '🇮🇳' },
  { code: 'ID', label: 'Indonésie', flag: '🇮🇩' },
  { code: 'IQ', label: 'Irak', flag: '🇮🇶' },
  { code: 'IR', label: 'Iran', flag: '🇮🇷' },
  { code: 'IE', label: 'Irlande', flag: '🇮🇪' },
  { code: 'IS', label: 'Islande', flag: '🇮🇸' },
  { code: 'IL', label: 'Israël', flag: '🇮🇱' },
  { code: 'IT', label: 'Italie', flag: '🇮🇹' },
  { code: 'JM', label: 'Jamaïque', flag: '🇯🇲' },
  { code: 'JP', label: 'Japon', flag: '🇯🇵' },
  { code: 'JO', label: 'Jordanie', flag: '🇯🇴' },
  { code: 'KZ', label: 'Kazakhstan', flag: '🇰🇿' },
  { code: 'KE', label: 'Kenya', flag: '🇰🇪' },
  { code: 'KG', label: 'Kirghizistan', flag: '🇰🇬' },
  { code: 'KW', label: 'Koweït', flag: '🇰🇼' },
  { code: 'LA', label: 'Laos', flag: '🇱🇦' },
  { code: 'LS', label: 'Lesotho', flag: '🇱🇸' },
  { code: 'LV', label: 'Lettonie', flag: '🇱🇻' },
  { code: 'LB', label: 'Liban', flag: '🇱🇧' },
  { code: 'LR', label: 'Liberia', flag: '🇱🇷' },
  { code: 'LY', label: 'Libye', flag: '🇱🇾' },
  { code: 'LI', label: 'Liechtenstein', flag: '🇱🇮' },
  { code: 'LT', label: 'Lituanie', flag: '🇱🇹' },
  { code: 'LU', label: 'Luxembourg', flag: '🇱🇺' },
  { code: 'MK', label: 'Macédoine du Nord', flag: '🇲🇰' },
  { code: 'MG', label: 'Madagascar', flag: '🇲🇬' },
  { code: 'MY', label: 'Malaisie', flag: '🇲🇾' },
  { code: 'MW', label: 'Malawi', flag: '🇲🇼' },
  { code: 'MV', label: 'Maldives', flag: '🇲🇻' },
  { code: 'ML', label: 'Mali', flag: '🇲🇱' },
  { code: 'MT', label: 'Malte', flag: '🇲🇹' },
  { code: 'MQ', label: 'Martinique', flag: '🇲🇶' },
  { code: 'MA', label: 'Maroc', flag: '🇲🇦' },
  { code: 'MU', label: 'Maurice', flag: '🇲🇺' },
  { code: 'MR', label: 'Mauritanie', flag: '🇲🇷' },
  { code: 'MX', label: 'Mexique', flag: '🇲🇽' },
  { code: 'MC', label: 'Monaco', flag: '🇲🇨' },
  { code: 'MN', label: 'Mongolie', flag: '🇲🇳' },
  { code: 'ME', label: 'Monténégro', flag: '🇲🇪' },
  { code: 'MZ', label: 'Mozambique', flag: '🇲🇿' },
  { code: 'NA', label: 'Namibie', flag: '🇳🇦' },
  { code: 'NP', label: 'Népal', flag: '🇳🇵' },
  { code: 'NI', label: 'Nicaragua', flag: '🇳🇮' },
  { code: 'NE', label: 'Niger', flag: '🇳🇪' },
  { code: 'NG', label: 'Nigeria', flag: '🇳🇬' },
  { code: 'NO', label: 'Norvège', flag: '🇳🇴' },
  { code: 'NZ', label: 'Nouvelle-Zélande', flag: '🇳🇿' },
  { code: 'OM', label: 'Oman', flag: '🇴🇲' },
  { code: 'UG', label: 'Ouganda', flag: '🇺🇬' },
  { code: 'UZ', label: 'Ouzbékistan', flag: '🇺🇿' },
  { code: 'PK', label: 'Pakistan', flag: '🇵🇰' },
  { code: 'PA', label: 'Panama', flag: '🇵🇦' },
  { code: 'PG', label: 'Papouasie-Nouvelle-Guinée', flag: '🇵🇬' },
  { code: 'PY', label: 'Paraguay', flag: '🇵🇾' },
  { code: 'NL', label: 'Pays-Bas', flag: '🇳🇱' },
  { code: 'PE', label: 'Pérou', flag: '🇵🇪' },
  { code: 'PH', label: 'Philippines', flag: '🇵🇭' },
  { code: 'PL', label: 'Pologne', flag: '🇵🇱' },
  { code: 'PT', label: 'Portugal', flag: '🇵🇹' },
  { code: 'QA', label: 'Qatar', flag: '🇶🇦' },
  { code: 'RO', label: 'Roumanie', flag: '🇷🇴' },
  { code: 'GB', label: 'Royaume-Uni', flag: '🇬🇧' },
  { code: 'RU', label: 'Russie', flag: '🇷🇺' },
  { code: 'RW', label: 'Rwanda', flag: '🇷🇼' },
  { code: 'SV', label: 'Salvador', flag: '🇸🇻' },
  { code: 'SN', label: 'Sénégal', flag: '🇸🇳' },
  { code: 'RS', label: 'Serbie', flag: '🇷🇸' },
  { code: 'SC', label: 'Seychelles', flag: '🇸🇨' },
  { code: 'SG', label: 'Singapour', flag: '🇸🇬' },
  { code: 'SK', label: 'Slovaquie', flag: '🇸🇰' },
  { code: 'SI', label: 'Slovénie', flag: '🇸🇮' },
  { code: 'SO', label: 'Somalie', flag: '🇸🇴' },
  { code: 'SD', label: 'Soudan', flag: '🇸🇩' },
  { code: 'LK', label: 'Sri Lanka', flag: '🇱🇰' },
  { code: 'SE', label: 'Suède', flag: '🇸🇪' },
  { code: 'CH', label: 'Suisse', flag: '🇨🇭' },
  { code: 'SR', label: 'Suriname', flag: '🇸🇷' },
  { code: 'SY', label: 'Syrie', flag: '🇸🇾' },
  { code: 'TJ', label: 'Tadjikistan', flag: '🇹🇯' },
  { code: 'TZ', label: 'Tanzanie', flag: '🇹🇿' },
  { code: 'TD', label: 'Tchad', flag: '🇹🇩' },
  { code: 'CZ', label: 'Tchéquie', flag: '🇨🇿' },
  { code: 'TH', label: 'Thaïlande', flag: '🇹🇭' },
  { code: 'TG', label: 'Togo', flag: '🇹🇬' },
  { code: 'TN', label: 'Tunisie', flag: '🇹🇳' },
  { code: 'TR', label: 'Turquie', flag: '🇹🇷' },
  { code: 'UA', label: 'Ukraine', flag: '🇺🇦' },
  { code: 'UY', label: 'Uruguay', flag: '🇺🇾' },
  { code: 'VE', label: 'Venezuela', flag: '🇻🇪' },
  { code: 'VN', label: 'Vietnam', flag: '🇻🇳' },
  { code: 'YE', label: 'Yémen', flag: '🇾🇪' },
  { code: 'ZM', label: 'Zambie', flag: '🇿🇲' },
  { code: 'ZW', label: 'Zimbabwe', flag: '🇿🇼' }
];